import i18n from "../../../i18n";

export const DietDairyTypes = {
  FOOD_DRINK: "food_drink",
  CORNSTARCH: "cornstarch",
  TRIHEPTANOIN: "triheptanoin",
  MCT_OIL: "mct_oil",
  GLYCOSADE: "glycosade",
};

export const dietDairyTypeToString = (type) => {
  switch (type) {
    case DietDairyTypes.FOOD_DRINK:
      return i18n.t("appText.dietDiary.foodDrink");
    case DietDairyTypes.CORNSTARCH:
      return i18n.t("appText.dietDiary.cornstarch");
    case DietDairyTypes.MCT_OIL:
      return "MCT Oil";
    case DietDairyTypes.TRIHEPTANOIN:
      return "Triheptanoin";
    case DietDairyTypes.GLYCOSADE:
      return i18n.t("appText.dietDiary.glycosade");
    default:
      return i18n.t("appText.dietDiary.foodDrink");
  }
};

export const getGlycosadeNutritionItems = () => {
  return [
    {
      title: i18n.t("appText.dietDiary.glycosade"),
      measures: [
        {
          serving_weight: 60,
          measure: i18n.t("appText.dietDiary.packet"),
          seq: 1,
          qty: 1,
        },
        {
          serving_weight: 1,
          measure: i18n.t("appText.dietDiary.grams"),
          seq: 1,
          qty: 1,
        },
        {
          serving_weight: 5,
          measure: i18n.t("appText.dietDiary.scoop"),
          seq: 1,
          qty: 1,
        },
      ],
      defaultMeasure: {
        serving_weight: 60,
        measure: i18n.t("appText.dietDiary.packet"),
        seq: 1,
        qty: 1,
      },
      fullNutrients: [
        {
          attr_id: 203,
          value: 0,
        },
        {
          attr_id: 204,
          value: 0,
        },
        {
          attr_id: 205,
          value: 53,
        },
        {
          attr_id: 208,
          value: 212,
        },
        {
          attr_id: 269,
          value: 0,
        },
      ],
      qty: 1,
      canRemove: false,
      selectedMeasure: {
        serving_weight: 60,
        measure: i18n.t("appText.dietDiary.packet"),
        seq: 1,
        qty: 1,
      },
    },
  ];
};

export const TRIHEPTANOIN_NUTRITION_ITEMS = [
  {
    title: "Triheptanoin",
    measures: [
      {
        serving_weight: 34,
        measure: "gram",
        seq: 1,
        qty: 1,
      },
      {
        serving_weight: 34,
        measure: "millilitre",
        seq: 1,
        qty: 1,
      },
    ],
    defaultMeasure: {
      serving_weight: 34,
      measure: "millilitre",
      seq: 1,
      qty: 1,
    },
    fullNutrients: [
      {
        attr_id: 203,
        value: 0,
      },
      {
        attr_id: 204,
        value: 1,
      },
      {
        attr_id: 205,
        value: 0,
      },
      {
        attr_id: 208,
        value: 8.3,
      },
      {
        attr_id: 269,
        value: 0,
      },
      {
        attr_id: 291,
        value: 0,
      },
      {
        attr_id: 301,
        value: 0,
      },
      {
        attr_id: 303,
        value: 0,
      },
      {
        attr_id: 307,
        value: 0,
      },
      {
        attr_id: 401,
        value: 0,
      },
      {
        attr_id: 606,
        value: 1,
      },
    ],
    qty: 1,
    canRemove: false,
    selectedMeasure: {
      serving_weight: 34,
      measure: "gram",
      seq: 1,
      qty: 1,
    },
  },
];

export const NUTRITION_FIELDS = [
  {
    title: "Calories",
    translationId: "appText.dietDiary.nutritionTable.calories",
    chartTitle: "",
    aboutMealLetter: "Calories",
    attr_id: 208,
    unit: "kcal",
    isVisibleInTable: true,
  },
  {
    title: "Total Fat",
    translationId: "appText.dietDiary.nutritionTable.totalFat",
    chartTitle: "appText.dietDiary.fats",
    aboutMealLetter: "Fats",
    attr_id: 204,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Saturated Fat",
    translationId: "appText.dietDiary.nutritionTable.saturatedFat",
    chartTitle: "",
    aboutMealLetter: "",
    attr_id: 606,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Sodium",
    translationId: "appText.dietDiary.nutritionTable.sodium",
    chartTitle: "",
    aboutMealLetter: "",
    attr_id: 307,
    unit: "mg",
    isVisibleInTable: true,
  },
  {
    title: "Total Carbohydrates",
    translationId: "appText.dietDiary.nutritionTable.totalCarbohydrates",
    chartTitle: "appText.dietDiary.carbs",
    aboutMealLetter: "Carbs",
    attr_id: 205,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Dietary Fiber",
    translationId: "appText.dietDiary.nutritionTable.dietaryFiber",
    chartTitle: "",
    aboutMealLetter: "",
    attr_id: 291,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Sugars",
    translationId: "appText.dietDiary.nutritionTable.sugars",
    chartTitle: "appText.dietDiary.sugars",
    aboutMealLetter: "Sugars",
    attr_id: 269,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Protein",
    translationId: "appText.dietDiary.nutritionTable.protein",
    chartTitle: "appText.dietDiary.protein",
    aboutMealLetter: "Protein",
    attr_id: 203,
    unit: "g",
    isVisibleInTable: true,
  },
  {
    title: "Vitamin A",
    translationId: "appText.dietDiary.nutritionTable.vitaminA",
    chartTitle: "",
    aboutMealLetter: "",
    attr_id: 318,
    unit: "IU",
    isVisibleInTable: true,
  },
  {
    title: "Vitamin C",
    translationId: "appText.dietDiary.nutritionTable.vitaminC",
    chartTitle: "",
    aboutMealLetter: "",
    attr_id: 401,
    unit: "mg",
    isVisibleInTable: true,
  },
  {
    title: "Calcium",
    translationId: "appText.dietDiary.nutritionTable.calcium",
    chartTitle: "",
    aboutMealLetter: "",
    attr_id: 301,
    unit: "mg",
    isVisibleInTable: true,
  },
  {
    title: "Iron",
    translationId: "appText.dietDiary.nutritionTable.iron",
    chartTitle: "",
    aboutMealLetter: "",
    attr_id: 303,
    unit: "mg",
    isVisibleInTable: true,
  },
];
